import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import {
  ProductionCenterParametersType,
  ProductionCenterType,
  ProductionCenterTypeEnum,
} from '../types';

import { productionCenterQueryKeys } from './query-keys';

export type TPatchProductionCenterParams = {
  id: string;
  description?: string | null;
  production_center_type: ProductionCenterTypeEnum;
  parameters?: ProductionCenterParametersType | null;
};

export async function patchProductionCenter({
  ...data
}: TPatchProductionCenterParams): Promise<ProductionCenterType> {
  return mediaManagerClient.patch(`/api/v1/production_centers/${data.id}`, data);
}

type MutationFn = typeof patchProductionCenter;

type TUsePatchProductionCenterParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchProductionCenter({ config }: TUsePatchProductionCenterParams = {}) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar el centro de producción'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El centro de producción se ha actualizado correctamente'));
      queryClient.invalidateQueries({ queryKey: productionCenterQueryKeys.all });
    },
    ...config,
    mutationFn: patchProductionCenter,
  });
}
